// Spanish

const lang = {
  gateMediaPreviewHeader: 'También te puede interesar',
  loadmore: 'Mostrar más',
  nextMedia: 'Próximos medios',
  previousMedia: 'Medios anteriores',
  closePost: 'Cerrar publicación',
  nextPost: 'Publicación siguiente',
  previousPost: 'Publicación anterior',
  outOfStock: 'Agotado',
  numberOfReviews(n) {
    return n === 1 ? 'opinión' : 'opiniones'
  },
  reportFormField: 'Introduzca un mensaje',
  reportPost: 'Publicación anterior',
  reportFormTitle: '¿Quieres denunciar esta imagen?',
  reportFormDetails:
    'Si crees que la imagen es inapropiada, ilegal o infringe los derechos de alguna persona, puedes denunciar el contenido. Si denuncias la imagen / texto, se notificará a los moderadores de contenido y se tomarán las medidas apropiadas.',
  reportFormMessagePlaceholder: 'Indique el motivo de su informe',
  reportFormMessageLabel: 'Mensaje',
  reportFormEmailLabel: 'Email',
  reportFormSubmitButtonText: 'Enviar informe',
  reportFormCancelButtonText: 'Cancelar',
  reportFormSentTitle: '¡Gracias por su informe!',
  reportFormSentCloseButtonText: 'Cerrar',
  cardAndTileAriaLabel:
    'A continuación se muestra una lista de las publicaciones en las cuentas de varias redes sociales',
  carouselAriaLabel:
    'A continuación se muestra un carrusel de las publicaciones en las cuentas de varias redes sociales',
  singleAriaLabel: 'A continuación se muestra una publicación de una cuenta en las redes sociales',
  poweredBy: 'Con tecnología de Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` publicada el ${date}` : ''
    const createdByString = userName ? ` por ${userName}` : ''
    return `Foto${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Sube tu contenido',
  openTheGate: 'Abrir el diálogo',
}

export default lang
